<template>
  <v-dialog v-model="open" max-width="600" content-class="sc-modal sc-modal--md" :key="cod_producao">
    <v-card v-if="open" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="closeFiltrosModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-filter-variant</v-icon>
        <div>
          <span class="sc-modal__title">Filtrar colaborações</span>
          <span class="sc-modal__subtitle">Selecione os filtros para refinar os resultados</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <!-- Redes sociais -->
        <div class="filtrar-section">
          <div class="filtrar-section-header">
            <v-icon small color="text_secondary" class="mr-2">mdi-share-variant</v-icon>
            <span class="filtrar-section-label">Redes sociais</span>
          </div>
          <div class="filtrar-chips">
            <label
              v-for="(item, index) in filtros_redes_sociais"
              :key="'rede-' + index"
              class="filtrar-chip"
              :class="{ 'filtrar-chip--active': filtros.includes(item.dsc_fonte_colaboracao) }"
            >
              <input
                type="checkbox"
                :value="item.dsc_fonte_colaboracao"
                v-model="filtros"
                @change="onChange"
                class="filtrar-chip-input"
              />
              {{ capitalize(item.dsc_fonte_colaboracao) }}
            </label>
          </div>
        </div>

        <!-- Conteúdo -->
        <div class="filtrar-section">
          <div class="filtrar-section-header">
            <v-icon small color="text_secondary" class="mr-2">mdi-image-multiple</v-icon>
            <span class="filtrar-section-label">Conteúdo</span>
          </div>
          <div class="filtrar-chips">
            <label
              v-for="item in filtros_por_tipo_de_media_options"
              :key="'media-' + item"
              class="filtrar-chip"
              :class="{ 'filtrar-chip--active': filtros_por_tipo_de_media.includes(item) }"
            >
              <input
                type="checkbox"
                :value="item"
                v-model="filtros_por_tipo_de_media"
                @change="onChange"
                class="filtrar-chip-input"
              />
              <v-icon x-small class="mr-1">{{ mediaIcon(item) }}</v-icon>
              {{ item === 'image' ? 'Imagem' : capitalize(item) }}
            </label>
          </div>
        </div>

        <!-- Lives -->
        <div v-if="filtros_titulo_live && filtros_titulo_live.length" class="filtrar-section">
          <div class="filtrar-section-header">
            <v-icon small color="text_secondary" class="mr-2">mdi-video</v-icon>
            <span class="filtrar-section-label">Lives</span>
          </div>
          <div class="filtrar-chips">
            <label
              v-for="(item, index) in filtros_titulo_live"
              :key="'live-' + index"
              class="filtrar-chip"
              :class="{ 'filtrar-chip--active': filtros_por_live.includes(item.dsc_titulo_live_chat) }"
              :title="item.dsc_titulo_live_chat"
            >
              <input
                type="checkbox"
                :value="item.dsc_titulo_live_chat"
                v-model="filtros_por_live"
                @change="onChange"
                class="filtrar-chip-input"
              />
              <span class="filtrar-chip-text">{{ capitalize(item.dsc_titulo_live_chat) }}</span>
            </label>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { capitalizeString } from "@/utils/capitalizeString";
export default {
  props: {
    modalData: Array,
    dialog: { default: false, type: Boolean },
  },
  data() {
    return {
      filtros: JSON.parse(localStorage.getItem("@socialcam/filtro")) || [],
      debounce: null,
      debounce_filtro_por_live: null,
      filtros_por_tipo_de_media: JSON.parse(
        localStorage.getItem("@socialcam/filtros_por_tipo_de_media")
      ) || ["video", "audio", "image", "texto"],
      filtros_por_tipo_de_media_options: ["video", "audio", "image", "texto"],
      filtros_por_live: JSON.parse(localStorage.getItem("@socialcam/filtro_por_live")) || [],
    };
  },
  created() {
    const selectedProducao = this.$store.state.producoes.selectedProducao;
    if (selectedProducao?.cod_producao) {
      this.cod_producao = selectedProducao.cod_producao;
    }
  },
  async mounted() {
    const filtro_por_tipo_de_media = localStorage.getItem("@socialcam/filtros_por_tipo_de_media");
    const filtro_por_titulo_live = localStorage.getItem("@socialcam/filtros_por_live");

    if (filtro_por_tipo_de_media && filtro_por_tipo_de_media.length > 0) {
      this.filtros_por_tipo_de_media = JSON.parse(filtro_por_tipo_de_media);
    }

    if (filtro_por_titulo_live && filtro_por_titulo_live.length > 0) {
      this.filtros_por_live = JSON.parse(filtro_por_titulo_live);
    }

    await this.getColaboracoesFiltrosRedesSociais({ cod_producao: this.cod_producao });
    await this.getFiltrosLive({ cod_producao: this.cod_producao });

    this.updateActiveFilterState();
  },
  computed: {
    open: {
      get() { return this.dialog; },
      set(value) { if (!value) this.$emit("close"); },
    },
    ...mapGetters({
      filtros_redes_sociais: "colaboracoes_aprovadas/filtros_redes_sociais",
      cod_pasta: "pastas/getterCodPasta",
      filtros_titulo_live: "colaboracoes_aprovadas/filtros_titulo_live",
    }),
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas: "colaboracoes_aprovadas/getColaboracoesAprovadas",
      getColaboracoesFiltrosRedesSociais: "colaboracoes_aprovadas/getColaboracoesFiltrosRedesSociais",
      getFiltrosLive: "colaboracoes_aprovadas/getFiltrosLive",
      changeIfFiltroIsActive: "colaboracoes_aprovadas/changeIfFiltroIsActive",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
    }),
    capitalize(string) {
      return capitalizeString(string);
    },
    mediaIcon(type) {
      const icons = { video: "mdi-video", audio: "mdi-microphone", image: "mdi-image", texto: "mdi-text" };
      return icons[type] || "mdi-file";
    },
    closeFiltrosModal() {
      this.$emit("close");
    },
    updateActiveFilterState() {
      const allMediaSelected = this.filtros_por_tipo_de_media.length === this.filtros_por_tipo_de_media_options.length;
      const allRedesSelected = this.filtros.length === this.filtros_redes_sociais.length;
      const allLivesSelected = this.filtros_por_live.length === this.filtros_titulo_live.length;
      this.changeIfFiltroIsActive(!(allMediaSelected && allRedesSelected && allLivesSelected));
    },
    onChange() {
      localStorage.setItem("@socialcam/filtros", JSON.stringify(this.filtros));
      localStorage.setItem("@socialcam/filtros_por_tipo_de_media", JSON.stringify(this.filtros_por_tipo_de_media));
      localStorage.setItem("@socialcam/filtros_por_live", JSON.stringify(this.filtros_por_live));

      this.updateActiveFilterState();

      const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida") || "false");

      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.getColaboracoesAprovadas({
          page: 1,
          size: 5,
          cod_producao: this.cod_producao,
          flg_favorita: JSON.parse(localStorage.getItem("@socialcam/flg_favorita") || "false"),
          filtros: this.filtros,
          filtro_texto: localStorage.getItem("@socialcam/filtro_texto") || "",
          filtros_por_tipo_de_media: this.filtros_por_tipo_de_media,
          filtros_por_live: this.filtros_por_live,
          flg_exibida,
          cod_pasta: this.cod_pasta,
        });
        this.setCopyColaboracoesRecebidas(
          this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
        );
      }, 1500);
    },
  },
  beforeDestroy() {
    clearInterval(this.debounce_filtro_por_live);
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.cod_producao) {
        this.getColaboracoesFiltrosRedesSociais({ cod_producao: this.cod_producao });
      }
    },
    "$store.state.producoes.selectedProducao": function (newValue) {
      this.cod_producao = newValue.cod_producao;

      this.getColaboracoesFiltrosRedesSociais({ cod_producao: this.cod_producao });

      clearInterval(this.debounce_filtro_por_live);
      this.debounce_filtro_por_live = setInterval(async () => {
        await this.getFiltrosLive({ cod_producao: this.cod_producao });
      }, 10000);

      this.filtros_por_tipo_de_media = [...this.filtros_por_tipo_de_media_options];
      localStorage.setItem("@socialcam/filtros_por_tipo_de_media", JSON.stringify(this.filtros_por_tipo_de_media));
    },
    filtros_redes_sociais(newSources) {
      const stored = localStorage.getItem("@socialcam/filtros");
      if (stored && stored.length > 0) {
        const savedFiltros = JSON.parse(stored);
        // Auto-add any new sources that weren't in the saved filter
        const allSources = newSources.map((f) => f.dsc_fonte_colaboracao);
        const newOnes = allSources.filter((s) => !savedFiltros.includes(s));
        this.filtros = [...savedFiltros.filter((s) => allSources.includes(s)), ...newOnes];
        if (newOnes.length > 0) {
          localStorage.setItem("@socialcam/filtros", JSON.stringify(this.filtros));
          this.onChange();
        }
      } else {
        this.filtros = newSources.map((f) => f.dsc_fonte_colaboracao);
      }
    },
    filtros_titulo_live() {
      const stored = localStorage.getItem("@socialcam/filtros_por_live");
      if (stored && stored.length > 0) {
        if (JSON.stringify(this.filtros_por_live) !== stored) {
          const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida") || "false");
          clearTimeout(this.debounce);
          this.debounce = setTimeout(async () => {
            await this.getColaboracoesAprovadas({
              page: 1,
              size: 5,
              cod_producao: this.cod_producao,
              flg_favorita: JSON.parse(localStorage.getItem("@socialcam/flg_favorita") || "false"),
              filtros: this.filtros,
              filtro_texto: localStorage.getItem("@socialcam/filtro_texto") || "",
              filtros_por_tipo_de_media: this.filtros_por_tipo_de_media,
              filtros_por_live: this.filtros_por_live,
              flg_exibida,
              cod_pasta: this.cod_pasta,
            });
            this.setCopyColaboracoesRecebidas(
              this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
            );
          }, 1500);
        }
        this.filtros_por_live = JSON.parse(stored);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal shell (dialog, card, close, header, title, subtitle, body) comes from
// _modal.scss (sc-modal__*). The rules below are bespoke filter-section/chip
// styling — intentionally still scoped because chips are unique to this modal.
.filtrar-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filtrar-section-header {
  display: flex;
  align-items: center;
}

.filtrar-section-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filtrar-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filtrar-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid var(--sc-border-default);
  background: var(--sc-surface-tint);
  color: var(--v-text_secondary-base);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  user-select: none;

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    background: var(--sc-surface-tint-hover);
  }
}

.filtrar-chip--active {
  border-color: var(--v-primary-base);
  background: rgba(var(--sc-color-primary-rgb),0.1);
  color: var(--v-primary-base);

  .v-icon {
    color: var(--v-primary-base) !important;
  }
}

.filtrar-chip-input {
  display: none;
}

.filtrar-chip-text {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
